import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '@/config';

export const useGetStates = (country) => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStates = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = country ? { country } : {};
      const { data } = await axios.get(`${API_BASE_URL}/states`, {
        params,
      });
      setStates(data.states || []);
    } catch (err) {
      console.error('Error fetching states:', err);
      setError(err);
      setStates([]);
    } finally {
      setLoading(false);
    }
  }, [country]);

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);

  return {
    states,
    loading,
    error,
    refetch: fetchStates,
  };
};
